export default __webpack_public_path__ + "static/media/Veena_Kinhal_-_01_-_Haratanaya_Sree.2d183e89.mp3";